import React from 'react';
import { Box } from '@chakra-ui/react';

// Four-point sparkle with a small companion star, drawn in currentColor
const Sparkle = ({ size = 24, ...rest }) => (
    <Box as='svg' viewBox='0 0 24 24' width={`${size}px`} height={`${size}px`} fill='currentColor' aria-hidden='true' {...rest} >
        <path d='M10 2.5c.4 3.9 2.6 6.1 6.5 6.5-3.9.4-6.1 2.6-6.5 6.5-.4-3.9-2.6-6.1-6.5-6.5 3.9-.4 6.1-2.6 6.5-6.5z' />
        <path d='M17.5 13c.25 2.3 1.45 3.5 3.75 3.75-2.3.25-3.5 1.45-3.75 3.75-.25-2.3-1.45-3.5-3.75-3.75 2.3-.25 3.5-1.45 3.75-3.75z' />
    </Box>
);

export default Sparkle;
